import { CurrencyISO } from '@/constants/currencies';
import { faker } from '@faker-js/faker';

faker.seed(1000);

type Row = {
  ticker: string | null;
  currencyISO: CurrencyISO | null;
  date: Date | null;
  shares: number | null;
  price: number | null;
  cost: number | null;
  type: 'buy' | 'sell' | null;
};

const getRow = (): Row => {
  const price = Math.round(Math.random() * 100);
  const shares = Math.round(Math.random() * 100);
  return {
    ticker: faker.person.firstName(),
    currencyISO: 'USD',
    date: new Date(faker.date.anytime().toISOString().split('T')[0]),
    shares,
    price,
    cost: price * shares,
    type: Math.round(Math.random() * 100) % 2 ? 'buy' : 'sell',
  };
};

const MOCK_DATA: Row[] = [
  {
    ticker: 'NYSE:AAPL',
    currencyISO: 'USD',
    date: new Date('2021-02-01'),
    shares: 2,
    price: 10,
    cost: 20,
    type: 'buy',
  },
  {
    ticker: 'NYSE:GOOGL',
    currencyISO: 'USD',
    date: new Date('2021-03-01'),
    shares: 3,
    price: 11,
    cost: 33,
    type: 'buy',
  },
  {
    ticker: 'NYSE:AMZN',
    currencyISO: 'USD',
    date: new Date('2021-04-01'),
    shares: 4,
    price: 12,
    cost: 48,
    type: 'buy',
  },
  {
    ticker: 'NYSE:MSFT',
    currencyISO: 'USD',
    date: new Date('2021-05-01'),
    shares: 5,
    price: 13,
    cost: 65,
    type: 'buy',
  },
];

const getFakeData = (rowCount: number): Row[] => {
  const arr: ReturnType<typeof getRow>[] = [];
  for (let i = 0; i < rowCount; i++) {
    const row = getRow();
    arr.push(row);
  }

  return arr;
};

const getDefaultData = (rowCount: number): Row[] => {
  const arr: ReturnType<typeof getRow>[] = [];
  for (let i = 0; i < rowCount; i++) {
    arr.push({
      ticker: null,
      currencyISO: null,
      date: null,
      shares: null,
      price: null,
      cost: null,
      type: null,
    });
  }

  return arr;
};

export const getDumbyData = async (rowCount: number, useFakeData = false) => {
  if (TEST_RUNNER === 'cypress') return MOCK_DATA;
  if (useFakeData) return getFakeData(rowCount);
  return getDefaultData(rowCount);
};
